<template>
  <PageView>
    <a-card>
      <a-form-model layout="inline">
        <a-form-model-item label="仓库">
          <a-select
            v-model="addressId"
            :options="addressOptions"
            placeholder="选择仓库"
            style="width: 240px"
            @change="addressChange"
          />
        </a-form-model-item>
        <a-form-model-item label="调价类型">
          <a-radio-group v-model="type">
            <a-radio value="logistics">快递</a-radio>
            <a-radio value="goods">商品</a-radio>
          </a-radio-group>
        </a-form-model-item>
        <a-form-model-item>
          <a-popover title="批量调价" trigger="click" placement="bottom">
            <template #content>
              <div style="width: 300px">
                <div>
                  <a-radio-group v-model="batchType">
                    <a-space direction="vertical">
                      <a-radio :value="1">
                        按值计算
                        <a-input-number v-model="jjValue" :step="0.01" />
                      </a-radio>
                      <a-radio :value="2">
                        改为固定值
                        <a-input-number v-model="gdValue" :step="0.01" />
                      </a-radio>
                    </a-space>
                  </a-radio-group>
                </div>
                <div style="text-align: right; margin-top: 10px">
                  <a-button type="primary" @click="fillData">填充</a-button>
                  <a-button
                    type="primary"
                    @click="batchChange"
                    style="margin-left: 10px"
                  >
                    确认调价
                  </a-button>
                </div>
              </div>
            </template>
            <a-button type="primary">批量调价</a-button>
          </a-popover>
        </a-form-model-item>
      </a-form-model>
      <a-table
        v-if="type === 'goods'"
        style="margin-top: 10px"
        rowKey="id"
        ref="table"
        size="small"
        :columns="goodsColumns"
        :dataSource="goodsList"
        :pagination="false"
        :loading="goodsLoading"
        :row-selection="{
          selectedRowKeys: selectedRowKeysGoods,
          onChange: onSelectChange
        }"
      >
        <template slot="picture" slot-scope="text, record, index">
          <!-- <img :src="text" alt="" style="width: 40px; height: 40px" /> -->
          <lazy-img :src="text" style="width: 40px; height: 40px"/>
        </template>
        <template slot="goodsPart" slot-scope="text, record, index">
          <a-input-number v-model="record.goodsPart" :step="0.01" />
        </template>
        <template slot="enable" slot-scope="text, record, index">
          <a-switch
            v-model:checked="record.enable"
            checked-children="启用"
            un-checked-children="否"
          />
        </template>
        <template slot="action" slot-scope="text, record, index">
          <a-button @click="saveUpdate(record)" :loading="record.loading">
            保存设置
          </a-button>
          <a-popconfirm title="确定删除？" @confirm="removeItem(record)">
            <a-button
              v-if="record.priceObj"
              type="danger"
              style="margin-left: 10px"
            >
              删除
            </a-button>
          </a-popconfirm>
        </template>
      </a-table>
      <a-table
        v-else
        style="margin-top: 10px"
        ref="table"
        rowKey="id"
        size="small"
        :columns="logisticsColumns"
        :dataSource="logisticsList"
        :pagination="false"
        :loading="logisticsLoading"
        :row-selection="{
          selectedRowKeys: selectedRowKeysLogistics,
          onChange: onSelectChange2
        }"
      >
        <template slot="logisticsPart" slot-scope="text, record, index">
          <a-input-number v-model="record.logisticsPart" :step="0.01" />
        </template>
        <template slot="enable" slot-scope="text, record, index">
          <a-switch
            v-model:checked="record.enable"
            checked-children="启用"
            un-checked-children="否"
          />
        </template>

        <template slot="action" slot-scope="text, record, index">
          <a-button @click="saveUpdate(record)" :loading="record.loading">
            保存设置
          </a-button>
          <a-popconfirm title="确定删除？" @confirm="removeItem(record)">
            <a-button
              v-if="record.priceObj"
              type="danger"
              style="margin-left: 10px"
            >
              删除
            </a-button>
          </a-popconfirm>
        </template>
      </a-table>
    </a-card>
  </PageView>
</template>
<script>
import LazyImg from '@/components/lazyImg.vue'
import { STable } from "@/components";
import { PageView } from "@/layouts";
import {
  addressList,
  queryOemPriceList,
  addressLogisticsListByUser2,
  goodsListAll2,
  updateOemPrice,
  insertOemPrice,
  removeOemPrice
} from "@/api";
import { platformType } from "@/utils/util";

export default {
  props: {
    uid: {
      type: String,
      default: '0' // 默认是0  是管理员查  有值就是用户
    }
  },
  components: {
    STable,
    PageView,
    LazyImg
  },
  data() {
    return {
      goodsLoading: false,
      logisticsLoading: false,
      actLoading: false,
      enable: true,
      addressId: undefined, // 仓库ID
      type: "logistics", // 调价类型 logistics | goods
      goodsList: [], // 商品列表
      logisticsList: [], // 快递列表
      addressOptions: [], // 仓库列表
      batchLoading: false,
      batchType: 1, // 批量类型 1是加减 2还是固定值
      jjValue: 0,
      gdValue: 0,
      selectedRowKeysLogistics: [],
      selectedRowKeysGoods: [],
      goodsColumns: [
        {
          title: "主图",
          dataIndex: "picture",
          scopedSlots: { customRender: "picture" }
        },
        { title: "商品名", dataIndex: "name" },
        { title: "价格", dataIndex: "price" },
        {
          title: "调价",
          dataIndex: "goodsPart",
          scopedSlots: { customRender: "goodsPart" }
        },
        {
          title: "是否启用",
          dataIndex: "enable",
          scopedSlots: { customRender: "enable" }
        },
        {
          title: "操作",
          dataIndex: "action",
          scopedSlots: { customRender: "action" }
        }
      ],
      logisticsColumns: [
        {
          title: "快递名",
          dataIndex: "name",
          customRender: (_, record) =>
            `${record.name}(${platformType[record.platform]})`
        },
        { title: "价格", dataIndex: "price" },
        {
          title: "调价",
          dataIndex: "logisticsPart",
          scopedSlots: { customRender: "logisticsPart" }
        },
        {
          title: "是否启用",
          dataIndex: "enable",
          scopedSlots: { customRender: "enable" }
        },
        {
          title: "操作",
          dataIndex: "action",
          scopedSlots: { customRender: "action" }
        }
      ]
    };
  },
  created() {
    this.getAddressOptions();
  },
  methods: {
    // 填充数据
    fillData() {
      const { batchType, jjValue, gdValue } = this;
      const { selectedRowKeysLogistics, selectedRowKeysGoods, type } = this;
      if (type === "logistics") {
        if (!selectedRowKeysLogistics.length)
          return this.$message.info("请选择数据！");
        this.logisticsList.forEach(data => {
          const flag = selectedRowKeysLogistics.includes(data.id);
          if (flag) {
            const price = data.logisticsPart || 0;
            this.$set(
              data,
              "logisticsPart",
              batchType === 1
                ? Number(((price * 100 + jjValue * 100) / 100).toFixed(2))
                : gdValue
            );
          }
        });
      } else {
        if (!selectedRowKeysGoods.length)
          return this.$message.info("请选择数据！");
        this.goodsList.forEach(data => {
          const flag = selectedRowKeysGoods.includes(data.id);
          if (flag) {
            const price = data.goodsPart || 0;
            this.$set(
              data,
              "goodsPart",
              batchType === 1
                ? Number(((price * 100 + jjValue * 100) / 100).toFixed(2))
                : gdValue
            );
          }
        });
      }
    },
    async batchChange() {
      const { selectedRowKeysLogistics, selectedRowKeysGoods, type } = this;
      let data;
      if (type === "logistics") {
        data = this.logisticsList.filter(val =>
          selectedRowKeysLogistics.includes(val.id)
        );
      } else {
        data = this.goodsList.filter(val =>
          selectedRowKeysGoods.includes(val.id)
        );
      }
      if (!data.length) return this.$message.error("无数据！");
      this.batchLoading = true;
      for (let index = 0; index < data.length; index++) {
        const record = data[index];
        await this.saveUpdate(record, false);
      }
      this.addressChange();
      this.selectedRowKeysLogistics = [];
      this.selectedRowKeysGoods = [];
      this.batchLoading = false;
    },
    onSelectChange(selectedRowKeys) {
      this.selectedRowKeysGoods = selectedRowKeys;
    },
    onSelectChange2(selectedRowKeys) {
      this.selectedRowKeysLogistics = selectedRowKeys;
    },
    // 获取调价列表
    async getPriceList(showType) {
      this.goodsLoading = true;
      const res = await queryOemPriceList({
        uid: this.uid,
        pageSize: 10000000,
        showType,
        addressId: this.addressId
      });
      this.goodsLoading = false;
      return res.data?.list || [];
    },
    async getGoodsList(uid) {
      this.logisticsLoading = true;
      const res = await goodsListAll2({
        pageSize: 1000,
        uid
      });
      this.logisticsLoading = false;
      if (res.success) {
        const temp = JSON.parse(JSON.stringify(res.data.list));
        const priceRes = await this.getPriceList("goods");
        const temp2 = temp.map(val => {
          const find = priceRes.find(p => p.goodsId === val.id);
          return {
            ...val,
            priceObj: find,
            goodsPart: find?.goodsPart,
            enable: find ? find.enable : true
          };
        });
        this.goodsList = temp2;
      }
    },
    async getLogisticsList(uid) {
      const res = await addressLogisticsListByUser2(uid);
      if (res.success) {
        const temp = JSON.parse(JSON.stringify(res.data));
        const priceRes = await this.getPriceList("logistics");
        const temp2 = temp.map(val => {
          const find = priceRes.find(p => p.logisticsId === val.id);
          return {
            ...val,
            priceObj: find,
            logisticsPart: find?.logisticsPart,
            enable: find ? find.enable : true
          };
        });
        this.logisticsList = temp2;
        console.log("[temp2] ---> ", temp2);
      }
    },
    async getAddressOptions() {
      const res = await addressList();
      if (res.success) {
        this.addressOptions = res.data.map(val => ({
          label: val.name,
          value: val.id,
          uid: val.uid
        }));
      }
    },
    // 选择仓库 触发
    addressChange() {
      this.selectedRowKeysGoods = [];
      this.selectedRowKeysLogistics = [];
      const find = this.addressOptions.find(
        val => val.value === this.addressId
      );
      if (find) {
        this.getGoodsList(find.uid);
        this.getLogisticsList(find.uid);
      }
    },
    async batchUpdatePrice() {
      let updateArr = [];
      let insertArr = [];
      if (this.type === "logistics") {
        updateArr = this.logisticsList
          .filter(val => val.priceObj)
          .map(val => ({
            ...val.priceObj,
            logisticsPart: val.logisticsPart,
            enable: val.enable
          }));
        insertArr = this.logisticsList
          .filter(val => !val.priceObj)
          .map(val => ({
            uid: 0,
            logisticsId: val.id,
            logisticsPart: val.logisticsPart,
            createTime: new Date().getTime(),
            updateTime: new Date().getTime(),
            addressId: this.addressId,
            enable: val.enable
          }));
      }
      if (this.type === "goods") {
        updateArr = this.goodsList
          .filter(val => val.priceObj)
          .map(val => ({
            ...val.priceObj,
            goodsPart: val.goodsPart,
            enable: val.enable
          }));
        insertArr = this.goodsList
          .filter(val => !val.priceObj)
          .map(val => ({
            uid: 0,
            goodsId: val.id,
            goodsPart: val.goodsPart,
            createTime: new Date().getTime(),
            updateTime: new Date().getTime(),
            addressId: this.addressId,
            enable: val.enable
          }));
      }
      this.actLoading = true;
      for (let index = 0; index < updateArr.length; index++) {
        const data = updateArr[index];
        await updateOemPrice(data);
      }
      for (let index = 0; index < insertArr.length; index++) {
        const data = insertArr[index];
        await insertOemPrice(data);
      }
      this.actLoading = false;
      this.$message.success("操作成功！");
      this.addressChange();
    },
    async saveUpdate(record, isFresh = true) {
      const method = record.priceObj ? updateOemPrice : insertOemPrice;
      record.loading = true;

      let data = {};
      if (record.priceObj) {
        data = {
          ...record.priceObj,
          goodsPart: this.type === "logistics" ? 0 : record.goodsPart,
          logisticsPart: this.type === "logistics" ? record.logisticsPart : 0,
          enable: record.enable
        };
      } else {
        data = {
          uid: this.uid,
          goodsId: this.type === "logistics" ? "" : record.id,
          goodsPart: this.type === "logistics" ? 0 : record.goodsPart,
          logisticsId: this.type === "logistics" ? record.id : "",
          logisticsPart: this.type === "logistics" ? record.logisticsPart : 0,
          createTime: new Date().getTime(),
          updateTime: new Date().getTime(),
          addressId: this.addressId,
          enable: record.enable
        };
      }
      const res = await method(data);
      record.loading = false;
      if (res.success) {
        this.$message.success("操作成功！");
        isFresh && this.addressChange();
      } else {
        this.$message.error(res.msg);
      }
    },
    async removeItem(record) {
      const res = await removeOemPrice(record.priceObj.id);
      if (res.success) {
        this.$message.success("删除成功");
        this.addressChange();
      } else {
        this.$message.error(res.msg);
      }
    }
  }
};
</script>
